// extracted by mini-css-extract-plugin
module.exports = {"heading":"ArticleHeader_heading__5nWBt"};